import { Injectable } from '@angular/core';
import {Jsonp, Http, Headers, URLSearchParams, Response} from '@angular/http';
// import { Http, Response,HTTP_PROVIDERS } from '@angular/http';
import { Observable }     from 'rxjs/Observable';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {Config} from '../config';

@Injectable()
export class LocationService {
    // Observable navItem source
    private _navItemSource = new BehaviorSubject<Object>(0);
    // Observable navItem stream
    navItem$ = this._navItemSource.asObservable();
    // service command
    changeNav(Object) {
        this._navItemSource.next(Object);
    }
    
    
    locateServiceURL:string = "";
    concatenators:Array<string> = ['and', '&', 'at'];
    jsonpCallback:string = "?method=JSONP_CALLBACK";
    parsedAddress:Object = new Object;
    searchType:string = "";
    offset:number = 0;
    appSettings: Object = null;
    
    constructor(private http: Http, private jsonp:Jsonp){
        if(this.appSettings == null){
            this.appSettings = Config.config[0];
        }
        this.locateServiceURL = this.appSettings["AddressLocator"]["serviceUrl"];
    }
    
    // getAddressSuggestions(typedAddress):any{
    //     if(!typedAddress){
    //         this.changeNav(false);
    //         return new Array<Object>();
    //     }
    //     var urlAddress:string = this.constructURL(typedAddress);
        
    //     // return this.jsonp.get(urlAddress + "?method=JSONP_CALLBACK")
    //     //     .toPromise()
    //     //     .then(
    //     //         (response) => response.json()
    //     //     ).catch(this.handleError);
    //     if(urlAddress != ""){
    //         this.changeNav(true);
            
    //         return this.jsonp.get(urlAddress + this.jsonpCallback)
    //            .map(response => {
    //                 var suggestionsArray = response.json();
    //                 for (var sug of suggestionsArray){
    //                     sug["SuggestionType"] = this.searchType;
    //                 }
    //                 return suggestionsArray;
    //            }).catch(this.handleObservableError);
    //     }
    //     this.changeNav(false);
    //     return new Array<Object>();
    // }
    
    private handleObservableError(error:Response){
        return Observable.of([]);
        
    }

    private handleError(error: any) {
        console.error('An error occurred', error);
        return Promise.reject(error.message || error);
    }
    
    // constructURL(typedAddress:string):string{
    //     var url:string = "";
    //     this.parsedAddress = new Object();
    //     var parsedAddressArray:Array<string> = [typedAddress.substring(0, typedAddress.indexOf(" ")), typedAddress.substring(typedAddress.indexOf(" "))];
    //     if(Number(parsedAddressArray[0])){
    //         this.parsedAddress["streetNumber"] = parsedAddressArray[0];
    //         if(parsedAddressArray[1] != " "){
    //             parsedAddressArray[1] = parsedAddressArray[1].replace(/[ ]+/g, " ").trim();
    //         }
    //         this.parsedAddress["streetName"] = parsedAddressArray[1];
    //         if(this.searchType == "Streets"){
    //             this.parsedAddress["type"] = "Streets";
    //             url = this.locateServiceURL + "StreetAddresses/" + this.parsedAddress["streetNumber"] + "/" + parsedAddressArray[1];
    //             return url;
    //         }
    //         this.parsedAddress["type"] = "Address";
    //         url = this.locateServiceURL + "Addresses/" + this.parsedAddress["streetNumber"] + "/" + parsedAddressArray[1] + "/true/true/true";
    //         this.searchType = "Address";
    //         return url;
    //     }
    //     for (var conc of this.concatenators){
    //         if(typedAddress.toLowerCase().indexOf(" " + conc.toLowerCase() + " ") != -1 && typedAddress.toLowerCase().split(" " + conc.toLowerCase() + " ").length > 1 && typedAddress.toLowerCase().split(" " + conc.toLowerCase() + " ").indexOf("") == -1){
    //             var intersections:Array<string> = typedAddress.toLowerCase().split(" " + conc.toLowerCase() + " ");
    //             url = this.locateServiceURL + "Intersections/" + intersections[0] + "/" + intersections[1] + "/" + conc.toLowerCase();
    //             this.searchType = "Intersection";
    //             return url;
    //         }
    //     }
    //     return url;
    // }
    
    getAddressLocation(suggestion:Object){
        var locationUrl:string = "";
        if(suggestion["SuggestionType"] == "Address"){
            locationUrl = this.locateServiceURL + "AddressLocationWithParcelNumber/" + 
                suggestion["HouseNum"] + "/" + suggestion["Street"]["Tag"] + "/" + (suggestion["Unit"] == "" ? " " : suggestion["Unit"]) + 
                "/Unit/Parcel" + this.jsonpCallback;
        }else if(suggestion["SuggestionType"] == "Intersection"){
            locationUrl = this.locateServiceURL + "IntersectionLocation/" + suggestion["ID"] + this.jsonpCallback;
        }else if(suggestion["SuggestionType"] == "Streets"){
            locationUrl = this.locateServiceURL + "StreetLocation/" + suggestion["StreetNumber"] + "/" + suggestion["Tag"] + "/" + this.offset + this.jsonpCallback;
        }
        return this.jsonp.get(locationUrl)
            .toPromise()
            .then(
                (response) => response.json()
            ).catch(this.handleError);
    }

    getStreetRanges(){
        var streetName = this.parsedAddress["streetName"];
        var streetRangesURL:string = this.locateServiceURL + "Streets/" + streetName + this.jsonpCallback;
        return this.jsonp.get(streetRangesURL)
            .toPromise()
            .then(
                (response) => response.json()
            ).catch(this.handleError);
    }
}


// WEBPACK FOOTER //
// ./app/tools/addressLocator.service.ts